import { InterfaceLanguage } from '@/types/types';
import i18next from 'i18next';
import XHR from 'i18next-xhr-backend';
import { language, backendUrl } from './config';

function translationFileForDomains(): string[] {
    if (location.host.includes("thestarposter") || location.host.includes("nachthimmel")) {
        return ['starmap']
    }
    if (location.host.includes("myvoiceposter")) {
        return ['soundwave']
    }
    if (location.host.includes('maxandemma')) {
        return ['baby']
    }
    return ['starmap', 'soundwave', 'baby']
}


export default function initTranslations() {
    window.lng = language as InterfaceLanguage;

    const i18nextOptions = {
      backend: {
        loadPath: backendUrl+'/translations/{{lng}}/{{ns}}.json'
      },
      ns: ['editor', ...translationFileForDomains()],
      defaultNS: 'editor',
      lng: window.lng,
      fallbackLng: 'en',
      debug: false,
    }
    
    return i18next
        .use(XHR)
        .init(i18nextOptions);
}